import { motion } from "framer-motion";
import { useApiQuery } from "@/api/hooks/useApiQuery";
import { getFiles } from "@/entities/FileService/File.queries";
import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import { fileTableTheme } from "@/features/FileManagement/fileTableTheme";
import { DocumentType } from "@/entities/FileService/File.model";
import { formatDate } from "@/utils/misc/format";
import clsx from "clsx";
import { CreatorCell } from "@/features/FileManagement/components/CreatedByCell";
import { ContentTypeCell } from "@/features/FileManagement/components/ContentTypeCell";
import { getFiles as getAssociatedFiles } from "@/entities/DataAssociation/DataAssociation.queries";

export default function FilesPage() {
    const { data: files } = useApiQuery(getFiles);
    const { data: associatedFiles } = useApiQuery(getAssociatedFiles);
    const gridRef = useRef<AgGridReact>(null);

    if (!files || !associatedFiles) return null;

    return (
        <>
            <div>{/* fragment stuff */}</div>
            <motion.div className="flex size-full">
                <div
                    className={clsx("size-full px-6", "flex flex-col", "gap-3")}
                >
                    <div id="labeling-grid" className="size-full">
                        <AgGridReact
                            ref={gridRef}
                            theme={fileTableTheme}
                            rowData={files}
                            // getRowId={(params) => params.data.id}
                            // onCellClicked={onRowClicked}
                            columnDefs={[
                                {
                                    headerName: "Name",
                                    colId: "name",
                                    field: "name",
                                    pinned: "left" as const,
                                    suppressHeaderMenuButton: true,
                                    sortable: false,
                                    width: 600,

                                    // autoHeight: true,
                                    cellRenderer: (params) => {
                                        return (
                                            <div className="flex h-full items-center">
                                                <p className="body-s text-wrap">
                                                    {params.data?.name}
                                                </p>
                                            </div>
                                        );
                                    },
                                },
                                {
                                    headerName: "Content Type",
                                    colId: "contentType",
                                    suppressHeaderMenuButton: true,
                                    sortable: false,
                                    sort: "asc",

                                    valueGetter: (params) => {
                                        console.log(params.data);

                                        if (!params.data) return "unknown";

                                        const data = params.data;

                                        return (
                                            associatedFiles.find(
                                                (file) => file.id === data.id,
                                            )?.documentKind ||
                                            data.meta?.codatDataType ||
                                            data.meta?.userReportedUploadType ||
                                            "unknown"
                                        );
                                    },
                                    cellRenderer: (params) => {
                                        console.log(params);
                                        return (
                                            <ContentTypeCell
                                                type={params.value}
                                            />
                                        );
                                    },
                                },
                                {
                                    headerName: "Document Type",
                                    colId: "documentType",
                                    field: "documentType",
                                    suppressHeaderMenuButton: true,
                                    sortable: false,
                                    valueGetter: (params) => {
                                        const data = params.data;
                                        if (!data) return "unknown";

                                        const docType = data.documentType;
                                        const source = data.source;
                                        if (docType === DocumentType.RAW) {
                                            const sourceLabel =
                                                source.charAt(0).toUpperCase() +
                                                source
                                                    .slice(1)
                                                    .replace("_", " ")
                                                    .replace("ed", "");
                                            return "Raw - " + sourceLabel;
                                        }
                                        return (
                                            docType.charAt(0).toUpperCase() +
                                            docType.slice(1)
                                        );
                                    },
                                },
                                {
                                    headerName: "Date created",
                                    colId: "createdAt",
                                    suppressHeaderMenuButton: true,
                                    sortable: false,
                                    valueGetter: (params) => {
                                        if (!params.data) return "";

                                        return formatDate(
                                            params.data.createdAt,
                                            {
                                                hideTime: true,
                                                dateFormat:
                                                    "YYYY-MM-DDTHH:mm:ssZ",
                                            },
                                        );
                                    },
                                },
                                {
                                    headerName: "Creator",
                                    colId: "creator",
                                    suppressHeaderMenuButton: true,
                                    sortable: false,
                                    cellRenderer: (params) => {
                                        if (!params.data) return null;

                                        return (
                                            <CreatorCell
                                                createdByType={
                                                    params.data.createdByType
                                                }
                                                createdByUserId={
                                                    params.data.createdByUserId
                                                }
                                            />
                                        );
                                    },
                                },
                            ]}
                            defaultColDef={{
                                flex: 1,
                            }}
                            rowSelection={{
                                mode: "multiRow",
                                checkboxes: false,
                                headerCheckbox: false,
                                enableClickSelection: true,
                            }}
                        />
                    </div>
                </div>
            </motion.div>
        </>
    );
}
